var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fcont"},[_c('div',{staticClass:"info"},[_c('div',{staticClass:"text"},[_vm._v(" На данный момент проект переходит на новую архитектуру. "),_c('br'),_c('br'),_vm._v(" Мобильная версия сайта временно не доступна. "),_c('br'),_c('br'),_vm._v(" Приносим извинения за доставленные неудобства, мы стремимся сделать проект лучше. ")])])])
}]

export { render, staticRenderFns }